import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" data-testid="login-page">
      <div className="login-grid">
        {/* Left Hero */}
        <div className="hero-section">
          <div className="hero-content">
            <img src="/kompa-logo.png" alt="Kompa" className="kompa-logo-hero" />
            
            <div className="badge">
              <svg className="badge-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span>Sistema Seguro de Auditoría</span>
            </div>

            <h1 className="hero-title">
              Auditor <span className="highlight">Inteligente</span><br />Kompa
            </h1>
            <p className="hero-text">
              Sistema completo de gestión de expedientes con control de acceso por roles, búsqueda avanzada y auditoría detallada.
            </p>

            <div className="features">
              <div className="feature-item">
                <div className="feature-icon">🔒</div>
                <span>Control de acceso por roles</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📊</div>
                <span>Gestión completa de expedientes</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔍</div>
                <span>Búsqueda y filtros avanzados</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📝</div>
                <span>Historial de auditoría completo</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Login Card */}
        <div className="login-card">
          <div className="card-header">
            <div className="card-icon">
              <svg className="icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h2 className="card-title">Acceso al Sistema</h2>
            <p className="card-subtitle">Ingresa tus credenciales</p>
          </div>

          <form onSubmit={handleSubmit} data-testid="login-form">
            {error && (
              <div className="error-box" data-testid="error-message">
                <span>⚠️</span>
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Correo Electrónico</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@kompa.local"
                data-testid="email-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                data-testid="password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="submit-btn"
              data-testid="login-button"
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>

          <p className="footer-text">Sistema exclusivo para personal autorizado de Kompa</p>
        </div>
      </div>
    </div>
  );
};

export default Login;